import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    padding: 0 40px;

    @media (max-width: ${theme.breakpoints.md}) {
      padding: 0;
    }
  `}
`;

export const Row = styled.section`
  ${({ marginbottom }) => css`
    margin-bottom: ${marginbottom ? '10px' : '0px'};

    > header {
      box-shadow: none;
      padding: 16px 24px
    }
  `}
`;

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0px 0px 10px;
`;
